import { Route } from '@angular/router';
import {
  CategoryMetaDataResolver,
  CmsRouteResolver,
  ProductMetaDataResolver,
  ProductRouteGuard,
} from '@boels/shared-state';

export const productRoutes: Route[] = [
  {
    path: '',
    children: [
      {
        path: ':culture/c/:categoryId',
        loadComponent: () =>
          import('@boels/components').then(
            (m) => m.CategoryTemplateRendererComponent,
          ),
        canActivate: [ProductRouteGuard],
        resolve: {
          resolvedData: CategoryMetaDataResolver,
        },
        runGuardsAndResolvers: 'pathParamsChange',
        data: {
          defaultReuseStrategy: false,
          resetReuseStrategy: true,
        },
      },
      {
        path: ':culture/category/:categoryId',
        loadComponent: () =>
          import('@boels/components').then(
            (m) => m.ProductListTemplateRendererComponent,
          ),
        canActivate: [ProductRouteGuard],
        resolve: {
          resolvedData: CategoryMetaDataResolver,
        },
        runGuardsAndResolvers: 'pathParamsChange',
        data: {
          defaultReuseStrategy: false,
          resetReuseStrategy: true,
        },
      },
      {
        path: ':culture/:param/c/:categoryId',
        loadComponent: () =>
          import('@boels/components').then(
            (m) => m.CategoryTemplateRendererComponent,
          ),
        canActivate: [ProductRouteGuard],
        resolve: {
          resolvedData: CategoryMetaDataResolver,
        },
        runGuardsAndResolvers: 'pathParamsChange',
        data: {
          defaultReuseStrategy: false,
          resetReuseStrategy: true,
        },
      },
      {
        path: ':culture/:catLevel0/:name/c/:categoryId',
        loadComponent: () =>
          import('@boels/components').then(
            (m) => m.CategoryTemplateRendererComponent,
          ),
        canActivate: [ProductRouteGuard],
        resolve: {
          resolvedData: CategoryMetaDataResolver,
        },
        runGuardsAndResolvers: 'pathParamsChange',
        data: {
          defaultReuseStrategy: false,
          resetReuseStrategy: true,
        },
      },
      {
        path: ':culture/:param/:cat/:catLevel1/c/:categoryId',
        loadComponent: () =>
          import('@boels/components').then(
            (m) => m.ProductListTemplateRendererComponent,
          ),
        canActivate: [ProductRouteGuard],
        resolve: {
          resolvedData: CategoryMetaDataResolver,
        },
        runGuardsAndResolvers: 'pathParamsChange',
        data: {
          defaultReuseStrategy: false,
          resetReuseStrategy: true,
        },
      },
      {
        path: ':culture/p/:productCode',
        loadComponent: () =>
          import('@boels/components').then(
            (m) => m.CurrentProductTemplateRendererComponent,
          ),
        canActivate: [ProductRouteGuard],
        resolve: {
          resolvedData: ProductMetaDataResolver,
        },
        runGuardsAndResolvers: 'pathParamsChange',
        data: {
          defaultReuseStrategy: false,
          resetReuseStrategy: true,
        },
      },
      {
        path: ':culture/:catLevel0/:name/p/:productCode',
        loadComponent: () =>
          import('@boels/components').then(
            (m) => m.CurrentProductTemplateRendererComponent,
          ),
        canActivate: [ProductRouteGuard],
        resolve: {
          resolvedData: ProductMetaDataResolver,
        },
        runGuardsAndResolvers: 'pathParamsChange',
        data: {
          defaultReuseStrategy: false,
          resetReuseStrategy: true,
        },
      },
      {
        path: ':culture/:name/p/:productCode',
        loadComponent: () =>
          import('@boels/components').then(
            (m) => m.CurrentProductTemplateRendererComponent,
          ),
        canActivate: [ProductRouteGuard],
        resolve: {
          resolvedData: ProductMetaDataResolver,
        },
        runGuardsAndResolvers: 'pathParamsChange',
        data: {
          defaultReuseStrategy: false,
          resetReuseStrategy: true,
        },
      },
      {
        path: ':culture/:product/:productCode/:name',
        loadComponent: () =>
          import('@boels/components').then(
            (m) => m.CurrentProductTemplateRendererComponent,
          ),
        canActivate: [ProductRouteGuard],
        resolve: {
          resolvedData: ProductMetaDataResolver,
        },
        runGuardsAndResolvers: 'pathParamsChange',
        data: {
          defaultReuseStrategy: false,
          resetReuseStrategy: true,
        },
      },
      {
        path: ':culture/search/find',
        loadComponent: () =>
          import('@boels/components').then(
            (m) => m.ProductListTemplateRendererComponent,
          ),
        canActivate: [ProductRouteGuard],
        resolve: {
          resolvedData: CmsRouteResolver,
        },
        runGuardsAndResolvers: 'pathParamsChange',
        data: {
          defaultReuseStrategy: false,
          resetReuseStrategy: true,
        },
      },
      {
        path: '**',
        loadComponent: () =>
          import('@boels/components').then(
            (m) => m.ContentTemplateRendererComponent,
          ),
        canActivate: [ProductRouteGuard],
        resolve: {
          resolvedData: CmsRouteResolver,
        },
        runGuardsAndResolvers: 'pathParamsChange',
        data: {
          defaultReuseStrategy: false,
          resetReuseStrategy: true,
        },
      },
    ],
  },
];
